module.exports = new __parcel__URL__("ArbitrumLogo.4a7518b6.svg").toString();